import(/* webpackMode: "eager" */ "/frontend/src/app/login/page.tsx");
